<div class="mx-auto max-w-sm py-3">
  <div
    class="mx-auto flex size-14 items-center justify-center rounded-2xl bg-blue-50 text-primary-600"
  >
    <svg class="size-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="14" rx="2" stroke-width="1.8" />
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.8"
        d="m4 7 8 6 8-6"
      />
    </svg>
  </div>

  <h3 class="mt-5 text-center text-xl font-bold tracking-tight text-slate-900">
    Verificá tu identidad
  </h3>

  <p class="mt-2 text-center text-sm leading-6 text-slate-500">
    Para administrar tus sesiones, necesitamos confirmar que sos vos. Te
    enviamos un código de seguridad a tu correo electrónico.
  </p>

  <div
    class="mt-6 flex gap-3 rounded-xl border border-blue-100 bg-blue-50/70 p-4"
  >
    <svg
      class="mt-0.5 size-5 shrink-0 text-primary-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="9" stroke-width="1.8" />
      <path stroke-linecap="round" stroke-width="1.8" d="M12 11v5m0-8h.01" />
    </svg>

    <p class="text-sm leading-5 text-primary-900">
      El código es temporal. No lo compartas con nadie.
    </p>
  </div>

  <form class="mt-6 space-y-4" (ngSubmit)="verify()">
    <label
      for="verification-code"
      class="block text-sm font-semibold text-slate-700"
    >
      Código de verificación
    </label>

    <input
      id="verification-code"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="6"
      [ngModel]="code()"
      (ngModelChange)="onCodeChange($event)"
      name="verificationCode"
      placeholder="Ingresá los 6 dígitos"
      class="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-center text-lg tracking-[0.4em] text-slate-900 outline-none transition placeholder:text-sm placeholder:tracking-normal focus:border-primary-500 focus:ring-4 focus:ring-blue-100"
    />

    @if (error()) {
      <p role="alert" class="text-sm font-medium text-red-600">
        {{ error() }}
      </p>
    }

    <button
      type="submit"
      [disabled]="code().length !== 6 || loading()"
      class="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50"
    >
      @if (loading()) {
        Verificando...
      } @else {
        Verificar identidad
      }
    </button>
  </form>

  <div class="mt-5 text-center">
    <button
      type="button"
      (click)="resendVerificationCode()"
      [disabled]="loading()"
      class="text-sm font-semibold text-primary-600 transition hover:text-primary-700 disabled:opacity-50"
    >
      Reenviar código
    </button>
  </div>
</div>
